import axios from '../request';

export default {
  /**
   * 人员管理模块接口
  */

  // 获取部门/班组下拉信息
  GETDEPARTMENTDATA: () =>
    axios.post('/staff/depart/pulldownList'),
  // 岗位职责下拉信息
  GETSTATIONDATA: () =>
    axios.post('/staff/position/pulldown'),
  // 所有人员下拉
  GETSTAFFALLDATA: () =>
    axios.post('/staff/platUser/pulldown'),
  // 获取宿舍下人员
  GETFORDORMSTAFFALLDATA: (params) =>
    axios.post('/staff/platUser/pulldownfordorm', params),




  // 查询人员信息列表
  SEARCHMORTGAGEELIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url:'/staff/platUser/findList',
      data: {
        userType: params.userType,
        realName: params.realName,
        departId: params.departId,
        posId: params.posId,
        status: params.status
      }
    }),
  // 添加人员信息
  INSERTMORTGAGEEINFO: (params) =>
    axios.post('/staff/platUser/addPlatUser', params),
  // 修改人员信息
  UPDATEMORTGAGEEINFO: (params) =>
    axios.post('/staff/platUser/addPlatUser', params),
  // 删除人员信息
  DELETEMORTGAGEEINFO: (params) =>
    axios.post('/staff/platUser/delete', params),
  // 导出人员信息
  EXPORTSTAFFEXCEL: (params) =>
    axios.get('/staff/platUser/export', {params}),
  // 增加人脸识别
  insertFaceInfo: (params) =>
    axios.post('/staff/platUser/addFace', params),
  // 批量离场人员
  batchAllOffUser: (params) =>
    axios.post('/staff/platUser/delFace', params),

  /**
   * 宿舍模块接口 
  */

  // 查询宿舍列表信息
  SEARCHDORMITORYLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url:'/staff/dorm/findList',
      data: {
        buildId: params.buildId,
        floorNum: params.floorNum
      }
    }),
  // 添加宿舍信息
  INSERTDORMITORYINFO: (params) =>
    axios.post('/staff/dorm/addDorm', params),
  // 修改宿舍信息
  UPDATEDORMITORYINFO: (params) =>
    axios.post('/staff/dorm/addDorm', params),
  // 删除宿舍信息
  DELETEDORMITORYINFO: (params) =>
    axios.post('/staff/dorm/delete', params),
  // 获取宿舍信息详情
  GETDORMITORYINFO: (params) =>
    axios.post('/staff/dorm/getDormInfo', params),

  /**
   * 值班管理模块接口
   */

  // 查询值班列表信息
  SEARCHDUTYMANAGELIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url: '/staff/duty/findList',
      data: {
        dutyDate: params.dutyDate
      }
    }),
  // 添加值班管理信息
  INSERTDUTYMANAGEINFO: (params) =>
  axios.post('/staff/duty/addDuty', params),
  // 修改值班管理信息
  UPDATEDUTYMANAGEINFO: (params) =>
  axios.post('/staff/duty/addDuty', params),
  // 删除值班管理信息
  DATEDUTYMANAGEINFO: (params) =>
  axios.post('/staff/duty/delete', params),
  // 查询班组人员信息
  SEARCHGROUPALLUSERLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: 1,
        PageSize: 1000000
      },
      url: '/staff/group/groupUserList',
      data: {
        groupId: params.groupId,
        realName: params.realName
      }
    }),
  // 添加班组员工
  INSERTGROUPUSERINFO: (params) =>
    axios.post('/staff/group/groupUserAdd', params),
  // 删除班组员工
  DELETEGROUPUSERINFO: (params) =>
    axios.post('/staff/group/groupUserDelete', params),
  // 设为负责人
  CHANGESETADMIN: (params) =>
    axios.post('/staff/group/setGroupAdmin', params),
  // 取消设为负责人
  CALLCHANGESETADMIN: (params) =>
  axios.post('/staff/group/cancelGroupAdmin', params),

  /**
   * 组织架构模块接口
   */

  // 查询部门列表信息
  SEARCHDEPARTMENTLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url: '/staff/depart/findList',
      data: {
        departName: params.departName
      }
    }),
  // 添加部门列表信息
  INSERTDEPARTMENTINFO: (params) =>
    axios.post('/staff/depart/addDepart', params),
  // 修改部门列表信息
  UPDATEDEPARTMENTINFO: (params) =>
    axios.post('/staff/depart/addDepart', params),
  // 删除部门列表信息
  DELETEDEPARTMENTINFO: (params) =>
    axios.post('/staff/depart/delete', params),    
  // 获取部门用户信息
  getDepartmentUserData: (params) =>
    axios({
      method: 'post',
      url: '/staff/depart/departUserList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        departId: params.departId
      }
    }),


  // 查询班组列表信息
  SEARCHTEAMGROUPLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url: '/staff/group/findList',
      data: {
        groupName: params.groupName
      }
    }),
  // 添加班组信息
  INSERTTEAMGROUPINFO: (params) =>
    axios.post('/staff/group/addGroup', params),
  // 修改班组信息
  UPDATETEAMGROUPINFO: (params) =>
    axios.post('/staff/group/addGroup', params),
  // 删除班组信息
  DELETETEAMGROUPINFO: (params) =>
    axios.post('/staff/group/delete', params),


  /**
   * 区域负责人模块接口
  */
  
  // 查询区域负责人列表信息
  SEARCHDISTRICTLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url: '/staff/area/findList',
      data: {
        areaName: params.areaName,
        areaAdminName: params.areaAdminName
      }
    }),
  // 添加区域负责人信息
  INSERTDISTRICTINFO: (params) =>
    axios.post('/staff/area/addArea', params),
  // 修改区域负责人信息
  UPDATEDISTRICTINFO: (params) =>
  axios.post('/staff/area/addArea', params),
  // 删除区域负责人信息
  DELETEDISTRICTINFO: (params) =>
  axios.post('/staff/area/delete', params),
  // 获取区域负责人信息详情
  GETDISTRICTINFODATA: (params) =>
  axios.post('/staff/area/getAreaInfo', params),
  /**
   * 岗位职责模块接口
  */

  // 查询岗位职责信息
  SEARCHSTATIONLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        PageSize: params.pageSize
      },
      url: '/staff/position/findList',
      data: {
        posName: params.posName
      }
    }),
  // 添加岗位职责信息
  INSERTSTATIONINFO: (params) =>
    axios.post('/staff/position/addPosition', params),
  // 修改岗位职责信息
  UPDATESTATIONINFO: (params) =>
    axios.post('/staff/position/addPosition', params),
  // 删除岗位职责信息
  DELETESTATIONINFO: (params) =>
    axios.post('/staff/position/delete', params),
}